import Vue from 'vue';
import { Servicelayer } from '../../plugins/servicelayer';
import App from '../generated/api/App';

export default (service: Servicelayer) => ({
  ...App(service),

  getHealth() {
    return service.get('', { baseURL: `${Vue.$config.values['networking-api-base-url']}/health`, withCredentials: false });
  },

});
